export default __webpack_public_path__ + "static/media/Enproject.765a9757.png";